<div *ngIf="showTooltip" class="eva-3-tooltip eva-3-tooltip--coachmark -white -not-hover {{ position }} -info -show-tooltip">
  <ng-content></ng-content>
  <div class="tooltip-container -eva-3-shadow-static-hover">
    <i class="tooltip-marker"></i>
    <i class="tooltip-close eva-3-icon-cross" (click)="close($event)"></i>
    <span class="tooltip-coachmark-img-container">
      <img src="https://media.staticontent.com/media/pictures/a8fcac2b-484a-447c-a17c-9c512410937d" width="70px" />
    </span>
    <span class="tooltip-coachmark-container">
      <span class="tooltip-coachmark-content">
        <h5 class="tooltip-title eva-3-h5 -eva-3-pr-xlg">{{ title }}</h5>
        <p class="tooltip-description">{{ description }}</p>
      </span>
    </span>
  </div>
</div>
